import { useId } from 'react';

/** Trusted badge — verified plus a review threshold. The gradient is baked in, so
 *  `className` controls size only. */
export default function ShieldCheckTrusted({ className }: { className?: string }) {
  // Per-instance id: `url(#id)` resolves to the first match in the document, so a
  // shared id blanks every badge after the first (a roster with two trusted players,
  // or a card rendered once for mobile and once for desktop).
  const gradientId = `shield-check-trusted-${useId().replace(/:/g, '')}`;

  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2.33362C14.5017 4.57267 17.7915 5.94968 21.4014 5.99866C21.5324 6.77955 21.6006 7.58187 21.6006 8.40002C21.6006 14.6698 17.5929 20.0033 12 21.9801C6.40731 20.0032 2.40041 14.6697 2.40039 8.40002C2.40039 7.58185 2.46852 6.77957 2.59961 5.99866C6.20937 5.94968 9.49838 4.57249 12 2.33362ZM16.085 9.11487C15.8172 8.8475 15.3829 8.84731 15.1152 9.11487L10.7998 13.4303L8.88574 11.5153C8.61795 11.2475 8.18283 11.2475 7.91504 11.5153C7.64764 11.783 7.64764 12.2173 7.91504 12.485L10.3154 14.8854C10.444 15.0138 10.6191 15.0856 10.8008 15.0856C10.9823 15.0854 11.1567 15.0137 11.2852 14.8854L16.085 10.0856C16.3527 9.81784 16.3526 9.38267 16.085 9.11487Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <radialGradient
          id={gradientId}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(6.87491 16.8744 -16.4911 6.71841 9.49991 8.87482)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDBA3F" />
          <stop offset="1" stopColor="#F54519" />
        </radialGradient>
      </defs>
    </svg>
  );
}
